import React from 'react';

import { SearchInput } from '../../SearchInput';
import { DATA_GRID_DEFAULT_SEARCH_PLACEHOLDER } from '../constants';
import { DataGridSearchConfig } from '../types';

export interface DataGridToolbarSearchProps {
  config: DataGridSearchConfig;
}

const DataGridToolbarSearch = ({ config }: DataGridToolbarSearchProps) => {
  const {
    placeholder = DATA_GRID_DEFAULT_SEARCH_PLACEHOLDER,
    value,
    onChange,
    debounceMs,
  } = config;
  const [draft, setDraft] = React.useState<string | null>(null);
  const debounceRef = React.useRef<ReturnType<typeof setTimeout>>();

  React.useEffect(
    () => () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    },
    []
  );

  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;
    if (!debounceMs) {
      onChange?.(nextValue);
      return;
    }
    setDraft(nextValue);
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      setDraft(null);
      onChange?.(nextValue);
    }, debounceMs);
  };

  return (
    <SearchInput
      placeholder={placeholder}
      value={draft ?? value ?? ''}
      onChange={onSearchChange}
      className="w-[320px]"
    />
  );
};

export { DataGridToolbarSearch };
